/**
 * ImportsPagination — footer pager (R-F9).
 *
 * Now a thin wrapper over the shared `TablePagination` (extracted 2026-08-05
 * when My Searches needed the same control). Markup, copy and the
 * `imports-pagination` test id are unchanged — this file keeps the imports-
 * specific noun and selector so the unit tests and the `upload-parse-list`
 * E2E spec keep passing untouched.
 */
import { TablePagination } from "../../../components/TablePagination";

export interface ImportsPaginationProps {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
}

export function ImportsPagination({ total, page, pageSize, onPageChange }: ImportsPaginationProps) {
  return (
    <TablePagination
      total={total}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      noun="people list"
      testId="imports-pagination"
    />
  );
}
